module.exports = __webpack_public_path__ + "files/a3208f43c4fc8e41d59d7c5c184f0c6d.png";